import * as React from 'react';
import { ICoreContext, getUrlSync, IAppSettings } from '@msdyn365-commerce/core';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getAttributeByTechnicalName } from '../../common/utilities/attributes-helpers';

export interface ISimpleProductItem {
    id: string;
    name: string;
    url?: string;
    PrimaryImageUrl?: string;
    wbsItemName?: string;
}

export interface ISimpleProductListProps {
    products: ISimpleProductItem[];
    title?: string;
    className?: string;
}

/**
 * Convertit une productList en ISimpleProductItem[]
 * @param productList Liste de produits configurée dans Site Builder
 * @param context Context de l'application
 * @returns ISimpleProductItem[]
 */
export const convertProductListToSimpleItems = (
    productList: Msdyn365.IProductList | undefined,
    context: ICoreContext
): ISimpleProductItem[] => {
    if (!productList || !productList.products || productList.products.length === 0) {
        return [];
    }

    const appSettings = context.app as IAppSettings;

    return productList.products
        .filter(product => product && product.Name)
        .map(product => {
            // Extraction du wbsItemName
            const wbsItemNameAttribute = getAttributeByTechnicalName(product.AttributeValues, 'WBS_ITEM_NAME', appSettings);
            const wbsItemName = wbsItemNameAttribute?.attribute.TextValue || '';

            return {
                id: product.RecordId.toString(),
                name: product.Name!,
                url:
                    getUrlSync('product', context.actionContext, {
                        product: { Name: product.Name!, RecordId: product.RecordId }
                    }) || '#',
                PrimaryImageUrl: product.PrimaryImageUrl || '',
                wbsItemName
            };
        });
};

/**
 * Composant simple pour afficher une liste de produits
 */
export const SimpleProductList: React.FC<ISimpleProductListProps> = ({ products, title, className = 'simple-product-list' }) => {
    if (!products || products.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {title && <h3 className={`${className}__title`}>{title}</h3>}
            <ul className={`${className}__items`}>
                {products.map(product => (
                    <li key={product.id} className={`${className}__item`}>
                        <a href={product.url} className={`${className}__link`}>
                            {product.wbsItemName || product.name}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};
